import { FC, Fragment } from 'react';
// Hooks
import useQuestionInterval from 'hooks/useQuestionInterval';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
import QuizTypes from 'types/QuizTypes';
import IQuiz from 'models/Quiz';
// Components
import QuestionMedia from './QuestionMedia';
import QuestionScoringBar from './QuestionScoringBar';
import QuestionPersonalityBar from './QuestionPersonalityBar';
import Question from './Question';
import ScoringAnswers from './ScoringAnswers';
import PersonalityAnswers from './PersonalityAnswers';
import QuestionClue from './QuestionClue';
import BeatTheExpertScoringBar from './BeatTheExpertScoringBar';
import BeatTheExpertQuestionProgress from './BeatTheExpertQuestionProgress';

const SimpleQuestion:FC = () => {
  const quiz:IQuiz = useAppSelector(selectQuiz);

  const { score, width, time } = useQuestionInterval();

  const isPollQuizzes = [QuizTypes.Poll, QuizTypes.RankingPoll].includes(quiz.type);
  const isBeatTheExpertQuiz = quiz.type === QuizTypes.BeatTheExpert;

  return (
    <Fragment>
      <div
        className="
          relative
          flex justify-center items-center
          overflow-hidden
        "
      >
        {!isBeatTheExpertQuiz ? <QuestionMedia /> : null}
        {!isPollQuizzes ? (
          <Fragment>
            <QuestionScoringBar score={score} width={width} />
            <QuestionPersonalityBar />
          </Fragment>
        ) : null}
      </div>
      <div style={{
        flex: 1,
        fontFamily: quiz.questionsSettings.font ? `${quiz.questionsSettings.font}, sans-serif` : 'initial'
      }}>
        {isBeatTheExpertQuiz ? (
          <BeatTheExpertQuestionProgress />
        ) : null}
        <Question />
        <BeatTheExpertScoringBar width={width} />
        <QuestionClue time={time} />
        <PersonalityAnswers />
        <ScoringAnswers score={score} time={time} />
      </div>
    </Fragment>
  )
}

export default SimpleQuestion;
